// 🎠 Carousel Styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// 🌍 Global Styles
import "../styles/globals.css";

// 🟢 WhatsApp Floating Button
import WhatsAppFloatingButton from "@/components/common/WhatsAppFloatingButton";

// 🔴 Import ErrorBoundary
import { ErrorBoundary } from "react-error-boundary";
import { Toaster } from "react-hot-toast";

// 🧠 Import Head for metadata
import Head from "next/head";

// 🧱 Fallback UI if something breaks
function ErrorFallback({ error, resetErrorBoundary }) {
  console.error("App crashed:", error); // Developer log

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center p-4 bg-gray-100 text-red-700">
      <h2 className="text-xl font-semibold mb-2">Oops! Something went wrong.</h2>
      <p className="mb-4">Please try refreshing the page or come back later.</p>
      <button
        className="px-4 py-2 bg-red-600 text-white rounded"
        onClick={() => {
          resetErrorBoundary();
          window.location.reload();
        }}
      >
        Reload Page
      </button>
    </div>
  );
}

export default function App({ Component, pageProps }) {
  return (
    <>
      <Head>
        {/* ✅ Favicon Link */}
        <link rel="icon" href="/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>SRK Trends</title>
      </Head>

      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <Component {...pageProps} />
        <Toaster position="top-center" reverseOrder={false} />
      </ErrorBoundary>

      <WhatsAppFloatingButton />
    </>
  );
}